// "DATE_OF_BIRTH_MISMATCH" / "date_of_birth_mismatch" -> "Date Of Birth Mismatch"
function toTitleCase(value: string): string {
  return value
    .toLowerCase()
    .split("_")
    .map((word) => (word ? word.charAt(0).toUpperCase() + word.slice(1) : word))
    .join(" ");
}

// "DATE_OF_BIRTH_MISMATCH" -> "Date Of Birth Mismatch"
export function formatDeclineReasonLabel(reason: string): string {
  return toTitleCase(reason);
}

// Check codes arrive as enum-style strings ("ADDRESS", "DATABASE_SCREENING").
// Displayed Title Case for the same reason statuses are — a grid full of
// SHOUTING codes reads badly next to ordinary labels.
export function formatCheckCodeLabel(checkCode: string): string {
  return toTitleCase(checkCode);
}

/**
 * Joins an applicant's names, tolerating either half being absent — both are
 * nullable on the API, and naively templating them renders "null null".
 * Returns an empty string when neither is present; callers supply their own
 * placeholder.
 */
export function formatApplicantName(
  firstName: string | null | undefined,
  lastName: string | null | undefined
): string {
  return [firstName, lastName].filter(Boolean).join(" ");
}

// Statuses arrive from the API in inconsistent casing ("valid", "PASSED",
// "in_progress"). Normalize every one of them to Title Case so the same status
// reads identically everywhere in the console, and so the i18n lookup only ever
// needs one key per status ("Valid", "Passed", ...).
export function formatStatusLabel(status: string): string {
  return toTitleCase(status);
}
